// This is a simple way to make sure that the global object is available in the browser environment.
window.global ||= window;

export {};
